import sendRequest from "../fetch"
import api from '../url'
import Qs from 'qs'
import { cleanParams } from "@/utils";

// 登录
export const userLogin = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "login", {
    data: _params,
    method: "POST",
  });
};
// 忘记密码
export const userForgetPassword = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "forgetPassword", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};
// 退出登录
export const userLogout = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "logout", {
    data: _params,
    method: "POST",
  });
};

// 用户管理 => 登出logout
export const userLoginOut = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "sys/user/logout", {
    data: _params,
    method: "POST",
  });
};

// 用户管理 => 修改密码
export const changePwd = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "sys/user/changePwd", {
    data: _params,
    method: "POST",
  });
};

// 用户管理 => 管理员账号切换到学生用户
export const toggleUser = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "toggleUser", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};

// 用户管理 => 首次登录点击我已知晓调用
export const agreePrivacy = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "agreePrivacy", {
    data: _params,
    method: "POST",
  });
};
// 学生重要信息（需要确认）-登录前
export const mainInfo = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "mainInfo", {
    data: _params,
    method: "GET",
  });
};
// 获取在线聊天TOKEN
export const chatToken = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + "chatToken", {
    data: _params,
    method: "GET",
  });
};

// 获取学生端菜单列表
export const getMenu = (params) => {
  return sendRequest(api.url + "menu", {
    data: params,
    method: "GET",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/login.js